import { lightSpacingAdmin } from '../figmaTokens/Admin';
export const spacing = [0, 0.25, 0.5, 0.75, 1, 1.25, 1.5, 2, 2.5, 3, 3.5, 4];
function getTokenNameByIndex(i) {
    return `spacing-${i.toString().padStart(2, '0')}`;
}
export const createSpacingTokens = () => {
    let result = {};
    spacing.forEach((token, i) => {
        result[getTokenNameByIndex(i)] = `${token}rem`;
    });
    result = Object.assign(Object.assign({}, result), lightSpacingAdmin);
    return result;
};
const SPACING_RATIO = 16;
export const createSpacingTokensNative = () => {
    const result = {};
    spacing.forEach((token, i) => {
        result[getTokenNameByIndex(i)] = token * SPACING_RATIO;
    });
    return result;
};
